var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgManageHostIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2496_1055)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.99998 14.9845C11.6819 14.9845 14.6666 11.9997 14.6666 8.31779C14.6666 4.63589 11.6819 1.65112 7.99998 1.65112C4.31808 1.65112 1.33331 4.63589 1.33331 8.31779C1.33331 11.9997 4.31808 14.9845 7.99998 14.9845Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.33337 9.65112C5.33337 9.65112 6.33337 10.9845 8.00004 10.9845C9.66671 10.9845 10.6667 9.65112 10.6667 9.65112",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 6.31787H6.0075",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 6.31787H10.0075",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2496_1055"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.317871)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManageHostIcon);
export default __webpack_public_path__ + "static/media/manage_host_icon.51ebdae2e8c6b53c5e1ba949d889dc6e.svg";
export { ForwardRef as ReactComponent };